module.exports = __webpack_public_path__ + "static/media/icon-word.73979905.svg";